<ngb-carousel *ngIf="images">
    
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img src="assets/images/slide1" alt="image" style="width:1500px;height:600px;"> 
      </div>
      <div class="carousel-caption">
        <h1>All eyes on you.</h1>
        <h5>Find it, love it, buy it.</h5>
      </div>
    </ng-template>

    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img src="assets/images/slide2" alt="image" style="width:1500px;height:600px;"> 
      </div>
      <div class="carousel-caption">
        <h1>Shopping for all seasons.</h1>
        <h5>Life is hard enough already. Let us make it a little easier.</h5>
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img src="assets/images/slide3" alt="image" style="width:1500px;height:600px;">
      </div>
      <div class="carousel-caption">
        <h1>Don’t worry, we have it.</h1>
        <h4>Favorite brands and hottest trends.</h4>
      </div>
    </ng-template>
    <ng-template ngbSlide>
      <div class="picsum-img-wrapper">
        <img src="assets/images/slide4" alt="image" style="width:1500px;height:600px;">
      </div>
      <div class="carousel-caption">
        <h2 style="color: black; background-color:powderblue; font-family:verdana;">An exciting place for the whole family to shop.</h2>
      </div>
    </ng-template>
  </ngb-carousel>